import { useSuspenseQuery } from '@tanstack/react-query';
import { SourcingService } from 'api-clients/monolith';
import { useEffect, useState } from 'react';

import { queryKeys } from '@/query-keys';

import { Card } from '../card';
import { ActionCenter } from './action-center';

interface AtRiskRecommendationProps {
  isExpanded: boolean;
  onCountChange: (count: number) => void;
}

export function AtRiskRecommendation({
  isExpanded,
  onCountChange,
}: AtRiskRecommendationProps) {
  const [isActionCenterOpen, setIsActionCenterOpen] = useState(false);

  const {
    data: { openings_at_risk: openingsAtRiskCount },
  } = useSuspenseQuery({
    queryKey: [...queryKeys.dashboard.recommendations.atRiskCount],
    queryFn: () =>
      SourcingService.getInternalApiSourcingDashboardOpeningsAtRiskCount(),
  });

  const hasRecommendation = openingsAtRiskCount > 0;

  useEffect(() => {
    onCountChange(hasRecommendation ? 1 : 0);
  }, [hasRecommendation, onCountChange]);

  const handleOpenActionCenter = () => {
    setIsActionCenterOpen(true);
  };

  if (!isExpanded || !hasRecommendation) return null;

  return (
    <>
      <Card
        recommendationType="AT_RISK"
        onClick={handleOpenActionCenter}
        value={openingsAtRiskCount}
      />

      <ActionCenter
        isOpen={isActionCenterOpen}
        onOpenChange={setIsActionCenterOpen}
      />
    </>
  );
}
